import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { AdminButton } from "../buttons/versionHistoryBtn";

import { Form, Formik } from "formik";
import * as Yup from "yup";
import "./modal.css";
import UploadInvoiceTable from "../tables/uploadInvoiceTable";
import { useDispatch } from "react-redux";
import { orderDetail } from "../../redux/actions/orderActions";
import UploadInvoiceImageModal from "./uploadInvoiceImage";

const UploadInvoiceTableModal = ({ show, handleClose, id, fetchOrderList }) => {
  const dispatch = useDispatch();
  const [orderDetailData, setOrderDetailData] = useState(null);
  const [formData, setFormData] = useState([]);
  const [showImgModal, setshowImgModal] = useState(false);

  useEffect(() => {
    if (show) {
      dispatch(orderDetail(id, onSuccess, onError));
    }
  }, [show]);

  useEffect(() => {
    setFormData(orderDetailData?.order?.orderProducts);
  }, []);

  const onSuccess = (data) => {
    console.log(data);
    setOrderDetailData(data.data.data);
  };

  const onError = (err) => {
    console.log(err);
  };

  const updateInvoice = (e, ele) => {
    ele[`${e.target.name}`] = e.target.value;
    let orderProducts = orderDetailData?.orderProducts;
    orderProducts.map((idx) => {
      idx.id == ele.id && (idx[`${e.target.name}`] = e.target.value);
    });
    setFormData(orderProducts);
  };

  const submitHandler = () => {
    formData.map((ele) => (ele["name"] = ele?.product?.product_name));
    handleClose();
    setshowImgModal(true);
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={handleClose}
        dialogClassName="upload-invoice-table-container col-10 px-5 mx-auto"
        size=""
      >
        <ModalHeader>
          <span className="fn_Nunito fw_700 fs_16 Medium_Purple my- px-0">
            Upload Invoice - {orderDetailData?.order_id}
          </span>
        </ModalHeader>
        <ModalBody className="text-nowrap">
          <div>
            <UploadInvoiceTable
              invoices={orderDetailData?.distributorInvoiceProducts}
              orderProducts={orderDetailData?.orderProducts}
              updateInvoice={updateInvoice}
            />
          </div>
          <div className="d-flex justify-content-end mt-3">
            <AdminButton
              width="120px"
              background="#7065e4"
              color="white"
              type="button"
              onClick={() => submitHandler()}
            >
              <span className="m-2">Next</span>
            </AdminButton>

            <AdminButton
              width="100px"
              color="#FF6F5B"
              border="1px solid #FF6F5B"
              type="button"
              onClick={() => handleClose()}
            >
              <span className="m-1">CLOSE</span>
            </AdminButton>
          </div>
        </ModalBody>
      </Modal>
      <UploadInvoiceImageModal
        fetchOrderList={fetchOrderList}
        show={showImgModal}
        closeFunc={() => setshowImgModal(false)}
        formData={formData}
        orderId={id}
      />
    </>
  );
};

export default UploadInvoiceTableModal;
